import React from "react";
import { formatDateNaturalLanguage, getDateAndTime } from "../../../utils";

export const PrintFinalDecision = ({ process, config, qrCode }) => {
    const department = process.unidade_administrativa_responsavel || {};

    return (
        <>
            <div className="cape" style={{maxWidth: '800px', margin: '16px'}}>
                <div style={{display: 'flex', textAlign: 'center', flexDirection: 'column', alignItems: 'center'}}>
                    <img src={'/assets/logos/' + config.company_owner_logo} width="200px" alt="logo"/><br/>
                    <div style={{textAlign: 'center'}}>
                        <strong>{config.company_state_description}</strong><br/>
                        <strong>{config.company_owner_name}</strong><br/>
                        <strong>{config.company_name}</strong><br/>
                        <strong>
                            {(department.descricao &&
                                (department.descricao !== department.sigla
                                    ? `${department.descricao} - ${department.sigla}`
                                    : department.descricao)
                            )?.toUpperCase()}
                        </strong>
                    </div>
                </div>

                <hr size="1" style={{borderColor: '#000'}}/>

                <strong>PROCESSO N°</strong> {process.numero}<br/>
                <strong>RECORRENTE:</strong> {process.nome_condutor.toUpperCase()}<br/>
                <strong>NOTIFICAÇÃO:</strong> {process.infracao.numero_ait.toUpperCase()}<br/>
                <strong>INFRAÇÃO:</strong> {process.infracao.descricao_tipo_infracao}<br/>
                <strong>DATA DA INFRAÇÃO:</strong> {getDateAndTime(process.infracao.data_infracao).date}<br/>
                <strong>HORÁRIO DA INFRAÇÃO:</strong> {getDateAndTime(process.infracao.data_infracao).time}<br/>
                <strong>LOCAL DA
                    INFRAÇÃO:</strong> {(process.infracao.logradouro_local_infracao.toUpperCase() + ' ' + process.infracao.complemento_local_infracao.toUpperCase())}<br/>

                <p></p>

                <div className="text-center">
                    <strong>DESPACHO</strong>
                </div>

                <p></p>

                <p><strong>I - DOS FATOS</strong></p>

                <div className="text-justify">
                    {process.fatos}
                </div>

                <p></p>

                <p><strong>II - DOS FUNDAMENTOS</strong></p>

                <div className="text-justify">
                    {process.fundamentos}
                </div>

                <p></p>

                <p><strong>III - DA DECISÃO</strong></p>

                <div className="text-justify">
                    {process.decisao}
                </div>

                <p></p>

                <div className="text-center">
                    É o parecer
                </div>

                <p></p>

                <div className="text-center">
                    {formatDateNaturalLanguage(process.data_limite_julgamento)}
                </div>

                <br/>
                <br/>
                <br/>

                <div className="text-center">
                    <strong>{process?.usuario_responsavel_atual ? process?.usuario_responsavel_atual?.pessoa?.nome.toUpperCase() : ''}</strong><br/>
                    <strong>Relator</strong>
                </div>

                <div
                    style={{
                        display: 'flex',
                        justifyContent: config.transport_permission_qrcode_alignment === 'left' ? 'flex-start' : 'flex-end'
                    }}>
                    <img src={qrCode} alt="QRCode" style={{width: '1.29in', height: '1.29in'}}/>
                </div>
            </div>
        </>
    )
}
